import i18next from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'

export const ACTIVATORS_GAP_WIDTH = 8

const options = { ns: getUserLanguage() }

export const REVIEW_ORIGINS = {
  callCenter: {
    icon: 'ui-icon-phone-call',
    text: i18next.t('колл-центр', options),
  },
  pdMobile: {
    icon: 'ui-icon-car-prodoctorov',
    text: i18next.t(window.IS_YDOC ? 'YDoc-мобиль' : 'ПроДокторов-мобиль', options),
  },
  site: {
    icon: 'ui-icon-site',
    text: i18next.t('сайт', options),
  },
}

export const AVG_ASSESSMENT_BOUNDARIES = {
  maxError: -0.4,
  maxWarning: 0.4,
}

export const ASSESSMENT_TEXT_COLOR = {
  default: 'text--text',
  error: 'text-error--text',
  warning: 'text-warning--text',
  success: 'text-success--text',
}

export const STAR_COUNTS = {
  min: 0,
  max: 5,
}
